export default class ExpiryStorage {
    /**
     * @param expires in seconds (e.g., 60*60*24*365 or 31536000 for a year)
     * @param defaultValue to be returned when storage is empty or expired
     */
    constructor(expires = 31536000) {
        this.expires = expires;
    }

    setItem(key, value, expires = this.expires) {
        const now = new Date();

        const item = {
            value: value,
            expires: now.getTime() + expires * 1000,
        };

        window.localStorage.setItem(key, JSON.stringify(item));
    }

    getItem(key, defaultValue = null) {
        const item = JSON.parse(window.localStorage.getItem(key));

        if (!item) return defaultValue;

        const now = new Date();

        if (now.getTime() > item.expires) {
            window.localStorage.removeItem(key);
            return defaultValue;
        }

        return item.value;
    }
}
